module.exports = __webpack_public_path__ + "media/product-benefits/hypoallergenic-77b9d58d.svg";